var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.26289,
    y: 1.19649,
    width: 20.3167,
    height: 20.3167,
    rx: 10.1583,
    stroke: "#C0C0C0",
    strokeWidth: 0.580476
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24414 10.3329C9.24414 10.0249 9.36646 9.72965 9.58419 9.51192C9.80191 9.29419 10.0972 9.17188 10.4051 9.17188H14.1776C14.33 9.17188 14.481 9.2019 14.6219 9.26025C14.7627 9.31859 14.8907 9.40411 14.9985 9.51192C15.1063 9.61973 15.1918 9.74771 15.2502 9.88857C15.3085 10.0294 15.3385 10.1804 15.3385 10.3329V14.1053C15.3385 14.2578 15.3085 14.4087 15.2502 14.5496C15.1918 14.6904 15.1063 14.8184 14.9985 14.9262C14.8907 15.034 14.7627 15.1196 14.6219 15.1779C14.481 15.2363 14.33 15.2663 14.1776 15.2663H10.4051C10.2527 15.2663 10.1017 15.2363 9.96084 15.1779C9.81998 15.1196 9.69199 15.034 9.58419 14.9262C9.47638 14.8184 9.39086 14.6904 9.33252 14.5496C9.27417 14.4087 9.24414 14.2578 9.24414 14.1053V10.3329Z",
    stroke: "#C0C0C0",
    strokeWidth: 0.661238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94347 13.4096C7.80983 13.3337 7.69867 13.2237 7.62129 13.0909C7.54392 12.9581 7.50308 12.8072 7.50293 12.6535V8.30032C7.50293 7.82147 7.89471 7.42969 8.37356 7.42969H12.7267C13.0532 7.42969 13.2308 7.59728 13.3797 7.865",
    stroke: "#C0C0C0",
    strokeWidth: 0.661238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/saveIcon.50c9027b12631499c389a7991c113472.svg";
export { ForwardRef as ReactComponent };